import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Viri have it hard",
  "description": "",
  "published": "2007-02-03T00:00:00.000Z",
  "redirect_from": ["/blog/viri-have-it-hard/swizec/295"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Ever wondered just how difficult it actually is to be a new virus that strives to kill off the world? Well now you can `}<a parentName="p" {...{
        "href": "http://www.newgrounds.com/portal/view/360724"
      }}>{`find out`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      